// extracted by mini-css-extract-plugin
module.exports = {"main":"layout-module--main--a1q6i","pageContainerWithMargin":"layout-module--page-container-with-margin--2Maj0","topLogo":"layout-module--top-logo--tj2Rt"};